<template>
    <van-overlay :show="visible">
        <div class="content">
            <transition name="van-fade" mode="out-in">
                <template v-for="(item, index) in list">
                    <NewbieGuideItem
                        v-if="index === active"
                        :key="`NewbieGuideItem${index}`"
                        :item="item"
                    ></NewbieGuideItem>
                </template>
            </transition>
        </div>
        <div>
            <div class="index">
                <div
                    v-for="(item, index) in list"
                    :key="index"
                    :class="index === active ? 'active' : ''"></div>
            </div>
            <div class="handle">
                <div class="handle_item next" @click="clickDone" v-if="active >= list.length -1">完成</div>
                <div class="handle_item skip" @click="clickClose" v-if="active < list.length -1">跳过</div>
                <div class="handle_item next" v-if="active < list.length -1" @click="clickNext">下一步</div>
            </div>
        </div>
    </van-overlay>
</template>

<script>
import NewbieGuideItem from './newbieGuideItem'
import { mapState } from 'vuex'
export default {
    name: 'NewbieGuide',
    components: { NewbieGuideItem },
    data: () => ({
        visible: false,
        active: 0,
        list: [
            require('./img/1.png'),
            require('./img/2.png'),
            require('./img/3.png'),
            require('./img/4.png'),
            require('./img/5.png'),
            require('./img/6.png'),
            require('./img/7.png')
        ],
        // 触发新手引导页面页面
        routerPaths: ['/my', '/consultation/list', '/doctorlist', '/freeclinic'],
        timer: null
    }),
    computed: {
        ...mapState('user', ['userInfo'])
    },
    watch: {
        '$route' (to, from) {
            if (to.path !== from.path) {
                this.checkNewbieGuide()
                if (this.routerPaths.includes(from.path)) {
                    this.visible = false
                    this.active = 0
                }
            }
        },
        'userInfo.id' (newVal, oldVal) {
            if (newVal !== oldVal && newVal) {
                this.checkNewbieGuide()
            }
        }
    },
    mounted () {
        this.checkNewbieGuide()
    },
    methods: {
        checkNewbieGuide () {
            if (!this.routerPaths.includes(this.$route.path)) return

            this.$nextTick(() => {
                let data = window.localStorage.getItem('newbieGuide')
                data = data && JSON.parse(data)

                if (!data || data.status == 0) {
                    if (this.$store.state.user.userInfo.id) {
                        this.api.user.isHaveConsult({ patientId: this.$store.state.user.userInfo.id }).then(({ data }) => {
                            if (!data) {
                                this.active = 0
                                this.visible = true
                            } else {
                                this.setNewbieGuideStorage()
                            }
                        })
                    }
                } else {
                    this.visible = false
                    this.active = 0
                }
            })
        },
        clickNext () {
            if (this.active < (this.list.length - 1)) {
                this.active ++
            }
        },
        setNewbieGuideStorage () {
            window.localStorage.setItem('newbieGuide', JSON.stringify({ status: 1 }))
        },
        clickClose () {
            this.setNewbieGuideStorage()
            this.visible = false
        },
        clickDone () {
            this.setNewbieGuideStorage()
            this.visible = false
        }
    }
}
</script>

<style scoped>
    .content {
        /*height: 80vh;*/
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .index {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 5px 0 25px;
    }
    .index>div{
        width: 1.6vw;
        height: 1.6vw;
        border-radius: 50%;
        background-color: #fff;
        margin: 0 1.6vw;
        opacity: 0.4;
    }
    .index>div.active { opacity: 1; }
    .handle {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .handle .handle_item {
        width: 24.8vw;
        height: 8.26vw;
        border-radius: 1.33vw;
        text-align: center;
        font-size: 3.2vw;
        font-weight: 500;
        line-height: 8.26vw;
        margin: 0 2.13vw;
    }
    .handle .handle_item.skip {
        color: #fff;
        border: 1px solid #fff;
    }
    .handle .handle_item.next {
        color: #000;
        background-color: #fff;
    }
</style>



// WEBPACK FOOTER //
// src/components/newbieGuide/index.vue